const DEFAULT_STATUS_COLORS: Readonly<Record<string, string>> = {
  active: 'success',
  accepted: 'success',
  success: 'success',
  completed: 'success',
  enabled: 'success',
  normal: 'success',
  pending: 'processing',
  queued: 'processing',
  running: 'processing',
  paused: 'warning',
  inactive: 'default',
  expired: 'default',
  disabled: 'default',
  failed: 'error',
  rejected: 'error',
  error: 'error',
  cancelled: 'default',
};

const DEFAULT_STATUS_LABELS: Readonly<Record<string, string>> = {
  active: '有效',
  inactive: '未启用',
  accepted: '已接受',
  success: '成功',
  succeeded: '成功',
  completed: '已完成',
  complete: '已完成',
  enabled: '已启用',
  normal: '正常',
  pending: '待处理',
  queued: '排队中',
  running: '进行中',
  processing: '处理中',
  paused: '已暂停',
  expired: '已过期',
  disabled: '已停用',
  failed: '失败',
  error: '异常',
  rejected: '已拒绝',
  cancelled: '已取消',
  canceled: '已取消',
};

export function resolveStatusColor(value?: string | number | null, explicitColor?: string): string | undefined {
  if (explicitColor) return explicitColor;
  return DEFAULT_STATUS_COLORS[String(value ?? '').toLowerCase()];
}

export function resolveStatusLabel(value?: string | number | null): string | number {
  const normalized = String(value ?? '').toLowerCase();
  return DEFAULT_STATUS_LABELS[normalized] ?? value ?? '-';
}

export function normalizeRiskReason(value: string): string {
  return value.trim();
}
